module.exports = new __parcel__URL__("73091300.77ee0ebd.png").toString();